import * as echarts from '@kyfe/echarts5'
import '../../style/tooltip.scss'

const commonColor = [
  '#ABA8EE',
  '#8C6AEA',
  '#7187EB',
  '#E5B5FA',
  '#7DE0E9',
  '#A6E9B6',
  '#FF977A',
  '#F3ACDE',
  '#AFAAFE',
  '#9CBAF9',
  '#3CD3A7',
  '#769BF8',
  '#63D6A6',
  '#FAE08D',
  '#EF87D3',
  '#FE86B6',
  '#6A3EE5',
  '#5EB9DF',
  '#FFB495',
  '#9B7CE6',
  '#6EE3B2',
  '#D3C0FA',
  '#91217F',
  '#D3C0FA',
  '#465CDD',
  '#ABA8EE',
  '#4AA2D2',
  '#510E6A',
  '#EF87AD',
  '#FFCB66',
  '#EF8790',
  '#86DB9A',
]

export const CHARTS_CONFIG = {
  color: commonColor,
  // x轴的滚动条基础配置
  dataZoom: {
    type: 'slider', // 类型为滑动条
    orient: 'horizontal', // 横向显示
    show: true,
    borderColor: 'transparent', // 显示滑动条
    backgroundColor: '#F2F3F7', // 背景色为半透明的红色
    handleSize: 0, // 滑动条两端圆柄的大小
    handleStyle: {
      color: 'transparent', // 圆柄颜色为透明，使其看起来是圆角
      borderWidth: 0,
    },
    fillerColor: 'rgba(118,83,214,.4)',
    borderRadius: 4,
    zoomOnMouseWheel: false,
    brushSelect: false,
    zoomLock: true,
    showDetail: false,
    showDataShadow: false,
    moveHandleIcon: 'none',
    start: 0, // 初始化滚动条开始位置
    end: 30,
    bottom: 4,
    height: 8, // 滑块高度
  },

  tooltip: {
    confine: true,
    backgroundColor: '#fff',
    padding: 0
  },
  tooltipAxisPointer: {
    shadow: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow',
        shadowStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: '#DEE5FF' },
            { offset: 1, color: 'rgba(255,255,255,0.00)' }
          ])
        },
        label: {
          show: true,
          color: '#fff',
          backgroundColor: '#FF9300',
        },
        z: 0
      },
    },
    line: {
      trigger: 'axis',
      axisPointer: {
        type: 'line',
        lineStyle: {
          color: '#9595CE',
          type: 'solid',
        },
        label: {
          show: true,
          color: '#fff',
          backgroundColor: '#FF9300',
        },
        z: 0
      }
    }
  },
  // 布局相关
  grid: {
    left: 16, // 这里的16 和 legend的位置一致
    right: 16,
    bottom: 20,
    top: 16 + 16 + 20,
    containLabel: true
  },
  // 图例相关
  legend: {
    type: 'plain',
    right: 16,
    top: 14,
    align: 'left',
    itemGap: 12,
    itemWidth: 16,
    itemHeight: 8,
    textStyle: {
      color: '#333',
      lineHeight: 14
    },
    padding: 5
  },
  // x轴基础配置
  xAxis: {
    triggerEvent: true,
    axisLine: {
      show: true,
      lineStyle: {
        color: '#DCDCDC'
      }
    },
    axisTick: {
      show: false,
    },
    axisLabel: {
      show: true,
      clickable: true, // 开启标签点击
      color: '#666'
    },
  },
  // x轴与竖线配合
  xAxisAxisPointer: {
    axisPointer: {
      show: true,
      type: 'line',
      label: {
        show: true,
        color: '#FF9300',
        backgroundColor: 'transparent'
      }
    }
  },
  // y轴相关
  yAxis: {
    splitLine: {
      show: true,
      lineStyle: {
        color: '#F0F0F2',
        type: 'dashed'
      }
    },
    // axisLabel: {
    //   show: true,
    //   margin: 0,
    //   color: '#666666',
    //   lineHeight: 12,
    //   fontSize: 12,
    //   align: 'right',
    // },
    // nameTextStyle: {
    //   color: '#666',
    //   fontSize: 12,
    //   align: 'right',
    //   lineHeight: 12,
    //   padding: 0
    // },
    nameGap: 16 + 4,
    nameLocation: 'end',
  },
  yAxisAlignLeft: {
    axisLabel: {
      show: true,
      margin: 0,
      color: '#666666',
      lineHeight: 12,
      fontSize: 12,
      align: 'left',
    },
    nameTextStyle: {
      color: '#666',
      fontSize: 12,
      align: 'left',
      lineHeight: 12,
      padding: 0
    },
  },
  yAxisAlignRight: {
    axisLabel: {
      show: true,
      margin: 0,
      color: '#666666',
      lineHeight: 12,
      fontSize: 12,
      align: 'right',
    },
    nameTextStyle: {
      color: '#666',
      fontSize: 12,
      align: 'right',
      lineHeight: 12,
      padding: 0
    },
  },
  seriesLineOpt: {
    type: 'line',
    smooth: true,
    symbolSize: 8,
    showSymbol: false,
  },
  seriesBarOpt: {
    type: 'bar',
    barWidth: 12,
    z: 2
  },
}


export class BasicConfig {
  constructor(options) {
    this.option = this.initBasicConfig(options)
  }
  initBasicConfig(options) {
    const { data } = options
    this.initBasicOption(options)
    this.data = data
  }
  initBasicOption(options) {
    const { data } = options
    this.series = this.createBasicSeries(data)
    this.color = this.createBasicColor()
    this.legend = this.createBasicLegend()
    this.tooltip = this.createBasicTooltip()
    this.title = this.createBasicTitle()
    this.grid = this.createGrid()
    this.xAxis = this.createXAxis()
    this.dataZoom = []
  }
  createBasicSeries() {
    return []
  }
  createBasicColor() {
    return commonColor
  }
  createBasicLegend() {
    return {}
  }
  createBasicTooltip() {
    return {}
  }
  createBasicTitle() {
    return {}
  }
  createTooltip(param, option = {}) {
    const { tooltipFormatterConfig = {}, propsConfig = {} } = option
    let { color, name, data, value } = param
    const tooltipList = (data && data.tooltipList) || []
    const createEchartsTooltipItem = (name, value, className = '') => {
      return `
        <div class="kye-form-echarts_tooltip_item ${className}">
          <div class="kye-form-echarts_tooltip_item-left">${name}</div>
          <div class="kye-form-echarts_tooltip_item-right">${value}</div>
        </div>
      `
    }
    const _getValue = (val, param, opt, index) => {
      const _formatContent = tooltipFormatterConfig[propsConfig.value || 'value']
      if (_formatContent && typeof _formatContent === 'function') {
        return _formatContent(val, param, opt, index)
      }
      return val
    }
    const _getLabel = (name, param, opt, index) => {
      const _formatLabel = tooltipFormatterConfig[propsConfig.name || 'name']
      if (_formatLabel && typeof _formatLabel === 'function') {
        return _formatLabel(name, param, opt, index)
      }
      return name
    }
    return `
      <div class="kye-form-echarts_tooltip_title">
        <div class="kye-form-echarts_tooltip_mark" style="background:${color}"></div>
        <span>${name}</span>
      </div>
      ${
        tooltipList.length === 0 ? createEchartsTooltipItem(_getLabel(name, param), _getValue(value, param)) : tooltipList.reduce((v, cur, index) => {
          const { name, value, className } = cur
          return v += createEchartsTooltipItem(_getLabel(name, param, cur, index), _getValue(value, param, cur, index), className)
        }, '')
      }
    `
  }
  createGrid() {
    return {}
  }
  createXAxis() {
    return {}
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-report-form/echarts/common/basic/basic-config.js